// extracted by mini-css-extract-plugin
export var oService = "service-module--o-service--Lhgrx";
export var oService__slider = "service-module--o-service__slider--1mV0n";
export var oService__slider__slide = "service-module--o-service__slider__slide--2HWUs";
export var oService__slider__slide__decoration = "service-module--o-service__slider__slide__decoration--3Bb1v";
export var oService__sliderMain = "service-module--o-service__slider--main--26iAp";
export var oService__swiper = "service-module--o-service__swiper--YjORr";
export var oService__controller = "service-module--o-service__controller--9K2Ue";
export var active = "service-module--active--k_k_F";
export var oService__attention = "service-module--o-service__attention--1RCo2";
export var oService__charactor = "service-module--o-service__charactor--1gaJl";
export var visible1 = "service-module--visible-1--2IhKF";
export var visible2 = "service-module--visible-2--1qq0X";
export var visible3 = "service-module--visible-3--2uGcK";
export var visible4 = "service-module--visible-4--3bsrY";
export var visible = "service-module--visible--2wps2";
export var subcopyBefore = "service-module--subcopy-before--nVBOo";
export var subcopyAfter = "service-module--subcopy-after--35J00";
export var service__slider = "service-module--service__slider--3a6kh";
export var standby = "service-module--standby--36e23";
export var lContent__inner = "service-module--l-content__inner--12W2n";